// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fc9L2","top":"styles_top__-P6JM","left":"styles_left__9AHAd","description":"styles_description__3_M1-"};